import React from 'react';

const RecentStories = ({ stories, onStorySelect }) => {
  // Function to extract headline from story content
  const getHeadline = (content) => {
    try {
      const h1Match = content.match(/<h1[^>]*>(.*?)<\/h1>/);
      if (h1Match) {
        return h1Match[1].replace(/<[^>]+>/g, '');
      }
      
      const strongMatch = content.match(/<strong[^>]*>(.*?)<\/strong>/);
      if (strongMatch) {
        return strongMatch[1].replace(/<[^>]+>/g, '');
      }
      
      return "Untitled Story";
    } catch (error) {
      return "Untitled Story";
    }
  };

  // Function to truncate text with ellipsis
  const truncateText = (text, maxLength = 80) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };

  return (
    <div className="results-section">
      <h2 className="text-2xl font-bold text-orange-500 mb-4">Recent Stories</h2>
      <div className="stories-container">
        {stories.map((story, index) => (
          <div key={index} className="story-item mb-4 p-3 border border-gray-200 rounded">
            <a 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                onStorySelect(story);
              }}
              className="text-lg font-medium text-orange-500 hover:text-orange-600"
            >
              {truncateText(getHeadline(story.content))}
            </a>
            <div className="text-sm text-gray-500 mt-1">
              {new Date(story.timestamp).toLocaleDateString()} • {story.views} views
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentStories;